/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {DamBasketInfo} from 'compob2b-libs';
import {debounceTime, take, takeUntil, tap} from 'rxjs/operators';
import {translations} from '../../../../../environments/translations.ru';
import {CrudConfig} from '../../../../admin-shared/interfaces/crud.config';
import {FILES_FORM} from '../files-forms.config';
import {DamCatalogComponent} from '../dam-table/dam-catalog.component'

@Component({
  selector: 'app-basket-list',
  templateUrl: './basket-list.component.html',
  styleUrl: './basket-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketListComponent extends DamCatalogComponent implements OnInit {
  dayInBasket: number;

  config: CrudConfig = {
    uri: '/dam/basket/files',
    columns: FILES_FORM,
    defaultSortColumn: 'header',
    defaultSortDirection: 'asc',
    title: translations.files,
  };

  ngOnInit(): void {
    super.setConfig(this.config);
    this.configure();

    this.route.queryParamMap.pipe(
      debounceTime(200),
      tap(_ => this.data = this.filterData()),
      takeUntil(this.unsubscribe)
    ).subscribe(_ => {
      this.cdr.detectChanges();
    });

    this.compoApiService
      .get<DamBasketInfo>('/dam/basket-info')
      .pipe(take(1))
      .subscribe(response => {
        this.dayInBasket = response.data.dayInBasket;
        this.cdr.detectChanges();
      });

  }

}
